<template>
  <div class="sort select">
    <label for="recent_activity"
           class="visually-hidden">
      Sort:
    </label>
    <select :v-model="dropdownModel"
            id="recent_activity"
            @change="dropdownOnChange"
            :placeholder="placeholder">
      <option class="option"
              v-for="option in dropdownOptions"
              :key="option.value"
              :value="option.value">
        {{option.label}}
      </option>
    </select>
  </div>
</template>
<script>
export default {
  props: [
    'dropdownModel',
    'dropdownOnChange',
    'dropdownOptions',
    'placeholder'
  ]
}
</script>
<style lang="scss">
  @import "~styles/utils.scss";
  .select {
    font-size: 1rem;
  }
</style>
